import React from "react";
import "../stylesheets/layout/beerSheet/Spinner.scss";

const Spinner = props => {
  return (
    <div
      className="lds-spinner"
      style={{ display: props.showSpinner ? "block" : "none" }}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Spinner;
